import { render, staticRenderFns } from "./NewUiModal.vue?vue&type=template&id=187bce50&"
import script from "./NewUiModal.vue?vue&type=script&lang=ts&"
export * from "./NewUiModal.vue?vue&type=script&lang=ts&"
import style0 from "./NewUiModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports